import { render, staticRenderFns } from "./Competencia.vue?vue&type=template&id=d4b591cc&scoped=true"
import script from "./Competencia.vue?vue&type=script&lang=js"
export * from "./Competencia.vue?vue&type=script&lang=js"
import style0 from "./Competencia.vue?vue&type=style&index=0&id=d4b591cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b591cc",
  null
  
)

export default component.exports